<template>
  <spam>
    <v-menu offset-y>
      <template #activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          :color="marketplaceId ? 'purple' : 'grey'"
          :dark="marketplaceId"
          :loading="retrying"
        >
          <v-icon v-if="marketplaceId">mdi-link-variant</v-icon>
          <v-icon v-else>mdi-link-variant-off</v-icon>
        </v-btn>
      </template>

      <v-card v-if="marketplaceId" width="300">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="purple--text text-wrap">
              Vinculado ao Marketplace
            </v-list-item-title>
            <v-list-item-subtitle class="mt-1 text-wrap">
              O marketplace permite realizar o orçamento de substituição
              automáticamente.
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions>
          <v-btn
            @click="handleClickGoToMarketplace()"
            block
            flat
            color="#f1f1f1"
            elevation="0"
            class="text-capitalize purple--text"
          >
            <v-icon left>mdi-open-in-new</v-icon>
            Ver
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else width="300">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="grey--text text-wrap">
              Sem vínculo com o marketplace
            </v-list-item-title>
            <v-list-item-subtitle class="mt-1 text-wrap">
              Não foi possível fazer o match com o marketplace, clique no botão
              abaixo para vincular manualmente ou tentar o match novamente
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <div class="mx-4 mt-2 pb-4">
          <v-btn
            @click="handleClickRetry()"
            :loading="retrying"
            block
            flat
            color="#f1f1f1"
            elevation="0"
            class="text-capitalize mb-2"
            small
          >
            <v-icon left>mdi-refresh</v-icon>
            Tentar novamente
          </v-btn>
          <v-btn
            @click="handleClickManualLink"
            block
            flat
            color="purple"
            elevation="0"
            class="text-capitalize"
            dark
          >
            <v-icon left>mdi-open-in-new</v-icon>
            Vincular
          </v-btn>
        </div>
      </v-card>
    </v-menu>
  </spam>
</template>

<script>
import { retryMarketplaceLink } from "@/services/products/products";
import { storeSession } from "@/services/marketplace/marketplace";

export default {
  mixins: [],

  components: {},

  props: {
    productId: Number,
    marketplaceId: Number,
  },

  data() {
    return {
      retrying: false,
      linking: false,
    };
  },

  methods: {
    handleClickGoToMarketplace() {
      window.open(
        `https://marketplace.portalhcm.com/products/${this.marketplaceId}`,
        "_blank"
      );
    },

    async handleClickManualLink() {
      this.linking = true;

      try {
        const { data } = await storeSession({
          lead_id: this.lead.id,
          product_id: this.productId,
        });

        console.log(data);

        window.location.href = data.session_url;
      } finally {
        this.linking = false;
      }
    },

    async handleClickRetry() {
      this.retrying = true;

      try {
        const { data } = await retryMarketplaceLink(this.productId);
        if (data.product_marketplace_id === null) {
          this.$store.commit("sendMessage", {
            text: "Nenhum produto compatível encontrado no marketplace",
          });
          return;
        }

        this.$emit("marketplaceIdChanged", data.product_marketplace_id);
        this.$store.commit("sendMessage", {
          text: "Vínculo bem sucedido",
        });
      } finally {
        this.retrying = false;
      }
    },
  },

  computed: {
    lead: function () {
      return this.$store.getters.getLead;
    },
  },
};
</script>
